//
// Module for Counseling Appointment Defaults
//
rs.module("content/system_/configuration/appointmentdefaults",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors) {

            // Unpack js selectors
            var appointmentDefaultsForm = $.js(jsSelectors.appointmentDefaultsForm);

            var organizerEmailSelect = appointmentDefaultsForm.js(jsSelectors.organizerEmailSelect);
            var organizerEmailSelectHelper = selectHelper.getHelper(organizerEmailSelect);
            var counselorAsOrganizerCheckBox = appointmentDefaultsForm.js(jsSelectors.counselorAsOrganizerCheckBox);

            // Toggle Organizer Email based on Counselor As Organizer selection
            counselorAsOrganizerCheckBox.change(function () {
                var disable = this.checked;
                organizerEmailSelectHelper.setDisabled(disable);

                if (disable) {
                    organizerEmailSelectHelper.setValue(null);
                    organizerEmailSelect.clearErrors();
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);